import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AttachmentsService } from '../services/attachments/attachments.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  showUserHeader:boolean = true;
  userInfo:any;
  constructor(private router: Router, private attachments:AttachmentsService) { }
  ngOnInit(): void {
      this.userInfo = sessionStorage.getItem('userInfo');
      this.userInfo = JSON.parse(this.userInfo);

      this.router.events.subscribe((ev) => {
        if (ev instanceof NavigationEnd) {

          this.showUserHeader = (this.router.url !== '/');
        }
      });
  }

  downloadManual() {
    const from : string = this.router.url === '/' ?  "homepage" : "landing";
    this.attachments.downloadManuale(from).subscribe({
      next: (response: any) => {
        const blob = new Blob([response]);
        let element = document.createElement('a');
        element.href = window.URL.createObjectURL(blob);
        element.download =   this.router.url === '/'  ?  "Cruscotto_QRSP.pdf" : "Manuale_Utente_QRSP.pdf";
        element.click();
        element.remove();
      }
    })
  }
}
